import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_app/admin/v3-agent/$runId')({});
